export { default } from './MauerBack';



// WEBPACK FOOTER //
// ./src/components/PageHeader/MauerBack/index.js